import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import { capitalToDashedLower } from 'helpers/regex';
import NavMobileItem from '../NavMobileItem/NavMobileItem';
import './NavMobileItemList.css';

const NavMobileItemList = ({
  options,
  title,
  filterItemValue,
  togglePin,
  showViewAll,
  onViewMore,
  viewMore,
  setNavState,
  isPinned,
}) => {
  const extraClassName = title ? `nav-mobile-item-list--${capitalToDashedLower(title)}` : '';
  return (
    <div className={`nav-mobile-item-list ${extraClassName}`}>
      { title && <h4 className="nav-mobile-item-list__title">{title}</h4>}
      {
        options.map(item => (
          <NavMobileItem
            {...item}
            key={item.value}
            filterItemValue={item.value}
            isActive={filterItemValue === item.value}
            togglePin={togglePin}
            isPinned={isPinned}
            setNavState={setNavState}
            hasPin
          />
        ))
      }
      {
        showViewAll && <Button onClick={onViewMore} className="nav-mobile-item-list__show-more">Show {viewMore ? 'Fewer' : 'More'} Projects</Button>
      }
    </div>
  );
};

NavMobileItemList.propTypes = {
  onViewMore: PropTypes.func,
  viewMore: PropTypes.bool,
  showViewAll: PropTypes.bool,
  title: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    isPinned: PropTypes.bool,
    value: PropTypes.string,
  })),
  filterItemValue: PropTypes.string,
  togglePin: PropTypes.func,
  isPinned: PropTypes.bool,
  setNavState: PropTypes.func,
};

NavMobileItemList.defaultProps = {
  options: [],
  isPinned: false,
};

export default NavMobileItemList;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileItemList/NavMobileItemList.jsx